import { X } from "lucide-react";

/** Consistent "not interested" control for Home media cards. Kept outside the
 * card's navigation link so pointer, keyboard and TV focus never open it. */
export function DismissButton({
  itemTitle,
  onDismiss,
  disabled = false,
}: {
  itemTitle: string;
  onDismiss: () => void;
  disabled?: boolean;
}): JSX.Element {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDismiss();
      }}
      disabled={disabled}
      aria-label={`Not interested in ${itemTitle}`}
      title="Not interested — don't show again; show fewer like this"
      className="absolute top-2 right-2 z-20 w-7 h-7 rounded-full bg-ink/90 border border-hairline text-parchment/80 opacity-70 group-hover:opacity-100 focus-visible:opacity-100 hover:text-vermilionHi hover:border-vermilion flex items-center justify-center transition disabled:opacity-30"
    >
      <X size={14} />
    </button>
  );
}
